import React, { useState, useEffect } from "react";
import "./Funding.css";
import { IoMenu } from "react-icons/io5";
// import FundingBox from "./component/FundingBox.js"
import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FaMapMarkerAlt } from "react-icons/fa";
import FundingAmountPlus from "./FundingAmountPlus.jsx";
import FundingDetail1 from "./component/FundingDetail1.jsx";
import FundingDetail2 from "./component/FundingDetail2.jsx";
import FundingPatch from "./component/FundingPatch.js";

function FundingDetail() {

    const location = useLocation();
    const { id } = useParams();

    let fundingData = JSON.parse(localStorage.getItem('펀딩데이터'))
    let [data,setData] = useState(fundingData.find((item) => {
        return item.id == id;
    }))
    const refreshData = () => {
        const updatedList = JSON.parse(localStorage.getItem('펀딩데이터'));
        const currentItem = updatedList.find(item => item.id == data.id);
        setData(currentItem);
    };

    if (data.rate < 100) {
        return <FundingDetail1 data={data} onUpdate={refreshData}/>
    } else {
        return <FundingDetail2 data={data}/>
    }
}


export default FundingDetail;